import { Box, Grid, Typography, Button } from "@mui/material";

import { SUPPORT_WEBSITE } from "@aclymatepackages/constants";

import Link from "../../atoms/mui/Link";

const SurveyError = ({
  message,
  href = SUPPORT_WEBSITE,
  btnText = "support"
}) => (
  <Box
    style={{ height: "100%" }}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography variant="h5" align="center">
          {message}
        </Typography>
      </Grid>
      <Grid item container justifyContent="center">
        <Grid item>
          <Link href={href}>
            <Button variant="contained" color="primary">
              {btnText}
            </Button>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

export default SurveyError;
